<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import TextOption from "%/dynamic-component-editor/options/text-option";
import IconOption from "%/dynamic-component-editor/options/icon";
import ButtonType from "%/dynamic-component-editor/options/button-type";
import ButtonSize from "%/dynamic-component-editor/options/button-size";

// Editor twin always draws its items so they stay editable; staging opens them from the engine's DropdownButton.
export default {
  name: "DropdownButtonContainer",
  extends: Container,
  elementPanelSettings: {
    alias: "Menu",
    displayName: "Menu",
    displayIcon: "mdi:dots-horizontal",
    tags: ["container", "menu", "dropdown", "actions"],
  },
  hidden: true,
  options: [TextOption, IconOption, ButtonType, ButtonSize],
  optionBundles: [
    new LayoutPositionOptions({
      "default.static-layout-direction": "vertical",
    }),
    SpacingOptions,
  ],
};
</script>
